module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Dropping in a Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("So often when photographing a landscape, all that is missing is a truly fabulous sky. Alternatively, how often have you witnessed a spectacular sky, but have looked in vain for a suitable foreground to complement it? Getting these two elements together can often prove challenging, but with a little know-how you can composite a sky from one file with the foreground of another.")]), _vm._v(" "), _c('div', {
    staticClass: "SBDIV"
  }, [_c('h4', {
    staticClass: "BOX-AHD"
  }, [_c('strong', [_vm._v("Keeping a ‘sky bank’")])]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_vm._v("Given the nature of our busy lives, most of us are unlikely to visit impressive landscapes on a daily basis, however interesting skies are much more available. It should be possible to photograph an attractive sky on virtually any day, but the important part is to ‘bank’ it for later use. With each sky I photograph, I note whether it was taken in the morning or in the evening, and whether the lighting was backlit or frontal, because the elements within composites need to be compatible. When shooting your skies, find a location that has an uninterrupted horizon so that you can get the best possible angle. Even if you are in the middle of town, point your camera upwards to exclude all the surrounding buildings.")])]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/8-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("Start image 1.")]), _vm._v(" Taken on a beautiful summer’s day, this landscape epitomizes all that I enjoy about this time of year. While there was plenty of interesting detail in the foreground, I wished that there had been some cloud in the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("Start image 2.")]), _vm._v(" When taking this shot I was aware that the foreground had little to offer, but realized that the sky could be used elsewhere. Both this and the landscape file were taken in the middle of the day with the sun over my left shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/10-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("Step 1.")]), _vm._v(" Your first task is to make an accurate selection of the sky you wish to replace. As it is even both in terms of colour and tone, this is an easy task. Use the Magic Wand tool set to Add to selection, and start as close to the horizon as you can. If the colour and tones of the sky are similar to the foreground, reduce the Tolerance; start with 20. Once you have successfully selected the areas nearest the horizon, increase the Tolerance and ‘mop up’ the rest of the selection.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/11-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("Step 2.")]), _vm._v(" Don’t forget to select the small areas of sky that appear through the trees. Having made your selection, go to "), _c('em', [_vm._v("Select > Modify > Expand")]), _vm._v(" and increase the selection by 3 pixels. This prevents the telltale white line appearing along the join. Feather the selection by 2 pixels ("), _c('em', [_vm._v("Select > Modify > Feather")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/11-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("Step 3.")]), _vm._v(" Open Start images 1 and 2. First, with Start image 2 active, go to "), _c('em', [_vm._v("Select")]), _vm._v(" "), _c('em', [_vm._v("All > Edit > Copy")]), _vm._v(". Now activate the landscape image and go to "), _c('em', [_vm._v("Edit > Paste Special > Paste Into")]), _vm._v(". The Landscape file now becomes the Background Layer, while the sky becomes Layer 1.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("Step 4.")]), _vm._v(" With the sky layer over the Background Layer, slight adjustments might be required. Use the Move tool to reposition the sky as accurately as you can. If the sky file is too big or too small, with Layer 1 active, go to "), _c('em', [_vm._v("Edit > Transform > Scale")]), _vm._v(", and with the Shift key depressed, scale up the sky by dragging one of the four outside bounding boxes.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/13-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_c('strong', [_vm._v("Finished image.")]), _vm._v(" By adding a new sky featuring wispy clouds, an otherwise uninteresting part of the image has been improved. It helps to use a sky that is compatible.")]), _vm._v(" "), _c('div', {
    staticClass: "SBDIV"
  }, [_c('h4', {
    staticClass: "TIP-AHD"
  }, [_c('strong', [_vm._v("TIP")])]), _vm._v(" "), _c('p', {
    staticClass: "TIP1"
  }, [_vm._v("If the landscape appears too dark for the new sky, make an Adjustment Layer, select Curves, and make the required tonal changes.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-427160c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/c02.vue
// module id = 69
// module chunks = 0